export default __webpack_public_path__ + "static/media/Ventair.5dd9fa75.mp4";